// extracted by mini-css-extract-plugin
export default {"cowContainer":"cow_cowContainer__9TqlM","readyPulse":"cow_readyPulse__9C7tJ","breedTarget":"cow_breedTarget__jJf9w","breedHover":"cow_breedHover__6cSiL"};